import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import React from "react";
import {Box} from "@mui/system";
import AdminCacheControllerService from "../../../API/admin/AdminCacheControllerService";

const useCacheData = (itemId) => {
    switch (itemId) {
        case 'cacheOrders':
            return [
                {text: "Чистить кэш единиц измерения", width: 260, api: AdminCacheControllerService.ordersUnits},
                {text: "Чистить кэш производителей", width: 250, api: AdminCacheControllerService.ordersManufacturers},
                {text: "Чистить кэш валют", api: AdminCacheControllerService.ordersCurrencies},
                {text: "Чистить весь кэш", api: AdminCacheControllerService.ordersAll}]
        case 'cacheModels':
            return [
                {text: "Чистить кэш единиц измерения", width: 260, api: AdminCacheControllerService.modelEstimateUnits},
                {text: "Чистить весь кэш", api: AdminCacheControllerService.modelEstimateAll}
            ]
        case 'cacheAuthorization':
            return [
                {text: "Чистить кэш валют", api: AdminCacheControllerService.authorizationCurrencies},
                {text: "Чистить весь кэш", api: AdminCacheControllerService.authorizationAll}
            ]
        default:
            break;
    }
}

const ClearCache = ({handleModalAlert, itemId}) => {
    const cacheData = useCacheData(itemId)

    const handleClick = (api) => {
        api().then(function () {
            handleModalAlert("Кеш успешно очищен", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }

    return <Box sx={{display: "flex", flexDirection: "column", gap: "20px"}}>
        {cacheData.map(el => {
            return <ButtonCreate
                icon={false} text={el.text} width={el.width || 165}
                onClick={() => handleClick(el.api)}
            />
        })}
    </Box>
}
export {ClearCache}